import PaginateButton from "../../../../shared/PaginateButton/PaginateButton";
import { loadMentors } from "../../../../store/features/AdminPanel/Mentor/MentorApi";
import { setMentorCurrentPage } from "../../../../store/features/AdminPanel/Mentor/MentorSlice";

import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import "./index.scss";

const MentorFooter = () => {
  const dispatch = useAppDispatch();
  const userState: any = useAppSelector((store: RootStore) => {
    return store.MentorSlice;
  });
  const handlePagination = (num: number) => {
    dispatch(setMentorCurrentPage(num+1));
        // dispatch(loadMentors({page:num+1}));
  };
  return (
    <div className="mentor__pagination__section">
      <PaginateButton
        paginate={handlePagination}
        totalRows={userState?.pagination_data?.total}
      />
    </div>
  );
};

export default MentorFooter;
